import { Link, useLocation } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  const location = useLocation();
  usePageMeta("页面不存在 - 樱桃视频", "你访问的页面不存在，返回首页继续浏览精彩视频内容。");

  return (
    <div className="w-full px-4 md:px-8 py-20 flex flex-col items-center justify-center text-center">
      <p className="text-[6rem] md:text-[9rem] leading-none font-heading font-black text-background-200 select-none">
        404
      </p>
      <h1 className="mt-4 text-xl md:text-2xl font-heading font-bold text-foreground-950">
        页面不存在
      </h1>
      <p className="mt-2 text-sm text-foreground-500">
        你访问的页面 <span className="font-mono text-foreground-700">{location.pathname}</span> 可能已被移除或暂时不可用。
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="rounded-md bg-primary-500 px-5 py-2.5 text-sm font-label font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          回到首页
        </Link>
        <Link
          to="/search"
          className="rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-label text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          搜索视频
        </Link>
      </div>
    </div>
  );
}